import { KlydoSearchFilters } from '../../../../api/klydo';

export enum KlydoFilterTab {
  All = 'All',
  NotSubmitted = 'Not Submitted',
  Review = 'Review',
  Public = 'Public',
  Collection = 'Collection',
  Rejected = 'Rejected',
}

/**
 * Tab -> api filter flags. The api's KlydoFilterBuilder owns what each flag
 * resolves to, so these are the semantic names it accepts and nothing more.
 *
 * `Public` asks the serving gate directly — `public.status === true`, i.e. public
 * right now. The client needs no clock for this: the api stores the flag and its
 * hourly cron flips a scheduled klydo. It deliberately does not use
 * `availableForCollection`, which means the opposite: unpublished and not in a
 * collection, i.e. still free to be put in one.
 *
 * `NotSubmitted` asks for klydos with no review STATE and no verdict behind it —
 * that absence IS the "never submitted" state, since there is no `draft` review
 * state to match against and never was one. Withdrawing after a rejection also
 * clears the state, so those klydos are excluded here and claimed by `Rejected`
 * instead: they still owe the reviewer an answer, and listing them as drafts
 * that were never judged would bury the rejection.
 */
export const getApiFiltersForTab = (
  tab: KlydoFilterTab,
): KlydoSearchFilters | undefined => {
  switch (tab) {
    case KlydoFilterTab.NotSubmitted:
      return { notSubmitted: true };
    case KlydoFilterTab.Review:
      return { pending: true };
    case KlydoFilterTab.Public:
      return { isPublic: true };
    case KlydoFilterTab.Collection:
      return { inCollection: true };
    case KlydoFilterTab.Rejected:
      return { rejected: true };
    case KlydoFilterTab.All:
    default:
      return undefined;
  }
};

export const filterTabs = Object.values(KlydoFilterTab);
